import { useSelector } from "../../../hooks";
import { shortNumberForm } from "../../../utils/numbers";
import styles from "./Level.module.scss";
import levelIcon from "./icons/Level.png";

export const Level = () => {
    const { level, exp } = useSelector(store => store.user.info);
    
    return (
        <div className={styles.level}>
            <div className={styles.levelInfo}>
                <div className={styles.levelBlock}>
                    <img src={levelIcon} className={styles.levelIcon} alt='star' />
                    
                    <div className={styles.levelText}>
                        Уровень <strong>{ level }</strong>
                    </div>
                </div>
                
                <div className={styles.progress}>{ `${ shortNumberForm(exp, 1) }/0` }</div>
            </div>
            
            <div className={styles.progressBar}>
                <div className={styles.progressFill} style={{ width: '0%'}}></div>
            </div>
        </div>
    );
}